import {
  supabaseGestionPension as supabase,
} from '../../../../config/settings/supabase-client'
import { getLogger } from '../../../../core/debuggers'
import { getPresenceTabId } from './presence'

const logger = getLogger('presenceHeartbeat')

export const HEARTBEAT_MS = 15000
export const ONLINE_WINDOW_MS = 45000

let trackedUserId = null
let timer = null
const idListeners = new Set()
let pollTimer = null

async function beat() {
  const userId = trackedUserId
  if (!userId) return

  const { error } = await supabase.from('user_presence').upsert({
    user_id: userId,
    tab_id: getPresenceTabId(),
    last_heartbeat_at: new Date().toISOString(),
  })

  if (error) {
    logger.warn('heartbeat upsert failed', error)
    return
  }

  if (idListeners.size > 0) {
    pollOnlineIds()
  }
}

async function leave() {
  const userId = trackedUserId
  if (!userId) return

  const { error } = await supabase
    .from('user_presence')
    .delete()
    .eq('user_id', userId)
    .eq('tab_id', getPresenceTabId())

  if (error) {
    logger.warn('heartbeat leave failed', error)
  }
}

function startTimer() {
  stopTimer()
  beat()
  timer = window.setInterval(beat, HEARTBEAT_MS)
}

function stopTimer() {
  if (timer) {
    window.clearInterval(timer)
    timer = null
  }
}

function onResume() {
  beat()
}

export function startTracking(userId) {
  if (!userId) return
  if (trackedUserId === userId && timer) return

  trackedUserId = userId
  document.removeEventListener('visibilitychange', onResume)
  document.addEventListener('visibilitychange', onResume)
  document.removeEventListener('resume', onResume)
  document.addEventListener('resume', onResume)
  window.removeEventListener('pageshow', onResume)
  window.addEventListener('pageshow', onResume)
  window.removeEventListener('focus', onResume)
  window.addEventListener('focus', onResume)

  startTimer()
}

export async function stopTracking() {
  stopTimer()
  document.removeEventListener('visibilitychange', onResume)
  document.removeEventListener('resume', onResume)
  window.removeEventListener('pageshow', onResume)
  window.removeEventListener('focus', onResume)
  await leave()
  trackedUserId = null
}

export async function fetchOnlineUserIds() {
  const { data, error } = await supabase.rpc('get_online_user_ids')
  if (error) {
    logger.warn('get_online_user_ids failed', error)
    return new Set()
  }

  const ids = new Set()
  ;(Array.isArray(data) ? data : data ? [data] : []).forEach((row) => {
    const id = typeof row === 'string' ? row : row?.user_id
    if (id) ids.add(id)
  })
  return ids
}

function notify(ids) {
  idListeners.forEach((listener) => listener(ids))
}

async function pollOnlineIds() {
  const ids = await fetchOnlineUserIds()
  notify(ids)
}

export function subscribeOnlineIds(onChange) {
  idListeners.add(onChange)
  pollOnlineIds()

  if (!pollTimer) {
    pollTimer = window.setInterval(pollOnlineIds, HEARTBEAT_MS)
  }

  return () => {
    idListeners.delete(onChange)
    if (idListeners.size === 0 && pollTimer) {
      window.clearInterval(pollTimer)
      pollTimer = null
    }
  }
}
